import Template from "./template";
import React from "react";
import { connect } from "react-redux";
import {
  getAsset,
  getTotalUserCreditCount,
  hasAvailableCopies,
  isActive,
  isAvailableToBorrow,
  isFetchAndActivatePending,
  isReturnable
} from "../../../redux/bridge/selectors";
import CenteredSpinner from "../../components/spinner/centered-spinner";
import { Translation } from "../../core/translate";
import {
  activateAsset,
  tryFetchAndActivate
} from "../../../redux/bridge/actions";
import { Button } from "@vitalsource/vstui";
import { actions as modalActions } from "../../../redux/modals";
import { launchBridgeBook } from "../../../redux/book/actions";

class Activator extends React.Component {
  componentDidMount() {
    this.props.init();
    this.tryRedirect();
  }

  componentDidUpdate() {
    this.tryRedirect();
  }

  tryRedirect() {
    if (this.props.active) {
      this.props.redirectToBook();
    }
  }

  renderBorrowPrompt() {
    const { activate, isbn, creditCount, returnable, assetTitle } = this.props;

    let borrowMessage = <Translation id="activate.you-must-borrow" />;
    if (creditCount === 1) {
      if (returnable) {
        borrowMessage = <Translation id="activate.last-borrow" />;
      } else {
        borrowMessage = <Translation id="activate.last-borrow-no-return" />;
      }
    }

    return (
      <Template
        title={<Translation id="activate.borrow-book" />}
        message={borrowMessage}
        isbn={isbn}
        link={<Translation id="activate.borrow" />}
        linkOnClick={activate}
        assetTitle={assetTitle}
      />
    );
  }

  renderUnavailablePrompt() {
    const { hasCopies, openModal, isbn, returnable, assetTitle } = this.props;

    let activateMessage = <Translation id="activate.all-in-use" />;
    if (hasCopies) {
      if (returnable) {
        activateMessage = (
          <Translation
            id="activate.limit-reached"
            returnAnotherItem={
              <Button inline onClick={openModal}>
                <Translation id="activate.return-another-item" />
              </Button>
            }
          />
        );
      } else {
        activateMessage = <Translation id="activate.limit-reached-no-return" />;
      }
    }

    return (
      <Template
        title={<Translation id="activate.book-unavailable" />}
        message={activateMessage}
        isbn={isbn}
        assetTitle={assetTitle}
      />
    );
  }

  render() {
    const { initPending, canBorrow, active } = this.props;

    if (active) {
      // Will redirect
      return null;
    }

    if (initPending) {
      return <CenteredSpinner />;
    }

    // initPending will take care of bypassing the prompt if we're
    // in an auto-activate scenario
    if (canBorrow) {
      return this.renderBorrowPrompt();
    }

    return this.renderUnavailablePrompt();
  }
}

export default connect(
  (state, ownProps) => ({
    canBorrow: isAvailableToBorrow(state, ownProps.isbn),
    hasCopies: hasAvailableCopies(state, ownProps.isbn),
    initPending: isFetchAndActivatePending(state, ownProps.isbn),
    active: isActive(state, ownProps.isbn),
    returnable: isReturnable(state, ownProps.isbn),
    creditCount: getTotalUserCreditCount(state),
    assetTitle: getAsset(state, ownProps.isbn)
      ? getAsset(state, ownProps.isbn).title
      : ""
  }),
  (dispatch, ownProps) => ({
    activate: () => dispatch(activateAsset(ownProps.isbn)),
    init: () => dispatch(tryFetchAndActivate(ownProps.isbn)),
    openModal: () => dispatch(modalActions.openModal("CreditsModal")),
    redirectToBook: () =>
      dispatch(launchBridgeBook(ownProps.isbn, { location: ownProps.location }))
  })
)(Activator);

export const ActivatorTest = Activator;
